// ABOUTME: Filters main navigation items according to company-enabled features.
// ABOUTME: Keeps full and compact menus aligned with feature flags from AuthContext.
import {
    isMcpEnabledForCompany,
    MCP_MENU_ITEMS
} from "utils/companyFeatureFlags";

const WHATSAPP_MENU_ITEMS = new Set([
    "whatsappinbox",
    "whatsappsettings",
    "addwhatsappapplicationflowmodel",
    "editwhatsappapplicationflowmodel",
    "allwhatsappapplicationflowmodels"
]);

export const getVisibleNavigationForCompany = (
    navigation: any,
    company: { whatsappEnabled?: boolean; mcpEnabled?: boolean }
) => {
    if (!Array.isArray(navigation?.features)) {
        return navigation;
    }

    const whatsappEnabled = company.whatsappEnabled === true;
    const mcpEnabled = isMcpEnabledForCompany(company);

    if (whatsappEnabled && mcpEnabled) {
        return navigation;
    }

    return {
        ...navigation,
        features: navigation.features
            .map((feature: Compleo.IObject) => ({
                ...feature,
                items: Array.isArray(feature.items)
                    ? feature.items.filter(
                          (item: Compleo.IObject) =>
                              (whatsappEnabled ||
                                  !WHATSAPP_MENU_ITEMS.has(item.uniqueName)) &&
                              (mcpEnabled ||
                                  !MCP_MENU_ITEMS.has(item.uniqueName))
                      )
                    : []
            }))
            .filter((feature: Compleo.IObject) => feature.items.length > 0)
    };
};
